import React from 'react';

import './paginator__up-button-icon.scss';

const PaginatorUpButtonIcon = () => {
    return <div className="paginator__up-button-icon" />;
};

export default PaginatorUpButtonIcon;
